import 'zone.js';
import {APP_INITIALIZER, enableProdMode, importProvidersFrom} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from './environments/environment.generated';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { routes } from './app/app-routing.module';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import {provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app/app-routing.module';
import {DBRendererModule, DBWindowRefModule, provideDbcrIcons} from '@db/db-core';
import {AuthService} from "./app/shared/services/auth.service";
import {SessionTimerService} from "./app/shared/services/session-timer.service";
import {TokenInterceptor} from "./app/core/interceptors/token.interceptor";
import {MockInterceptor} from "./app/core/interceptors/mock.interceptor";
import {initializeAuth, initializeSessionTimer} from "./app/app.module";
import { DBHeaderLinkConfigModule } from '@db/db-components';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideDbcrIcons({
      customIcons: [
        '/assets/icons/db-icons.svg',
        '/assets/icons/fy-icons.svg',
        '/assets/icons/pb-icons.svg'
      ],
    }),
    importProvidersFrom(AppRoutingModule, DBWindowRefModule, DBRendererModule, DBHeaderLinkConfigModule),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: "./assets/i18n/",
        suffix: ".json",
        enforceLoading: true,    // Adds cache-busting timestamp
        useHttpBackend: true
      }),
    })),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSessionTimer,
      deps: [SessionTimerService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    (environment.mock ? [{
      provide: HTTP_INTERCEPTORS,
      useClass: MockInterceptor,
      multi: true
    }] : [])
  ],
})
  .catch(err => console.error(err));
